require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lake-county-treatment-court.json") })
        }
      }, "path---lake-county-treatment-court");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lake-county-treatment-court!./.cache/json/lake-county-treatment-court.json
// module id = 919
// module chunks = 231608221292675